/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Delete_LabelInputs */

const en_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete key`)
};

const fr_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la clé`)
};

const de_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entf-Taste`)
};

const it_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasto Elimina`)
};

const ru_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить клавишу`)
};

const es_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecla de borrar`)
};

const zh_cn2_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除键`)
};

const ja_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除キー`)
};

const hi_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी हटाएं`)
};

const pt_pt2_options_api_keys_delete_label = /** @type {(inputs: Options_Api_Keys_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecla Delete`)
};

/**
* | output |
* | --- |
* | "Delete key" |
*
* @param {Options_Api_Keys_Delete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_delete_label = /** @type {((inputs?: Options_Api_Keys_Delete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Delete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_delete_label(inputs)
	if (locale === "de") return de_options_api_keys_delete_label(inputs)
	if (locale === "it") return it_options_api_keys_delete_label(inputs)
	if (locale === "ru") return ru_options_api_keys_delete_label(inputs)
	if (locale === "es") return es_options_api_keys_delete_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_delete_label(inputs)
	if (locale === "ja") return ja_options_api_keys_delete_label(inputs)
	if (locale === "hi") return hi_options_api_keys_delete_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_delete_label(inputs)
	return en_options_api_keys_delete_label(inputs)
});